export const textsES = [
    { id: 1, text: 'Modelo de simulación de ambiente' },
    { id: 2, text: 'Datos históricos de clima' },
    { id: 3, text: 'Tipos de suelo' },
    { id: 4, text: '100 mil datos de toda la red de ensayos Bayer' },
    { id: 5, text: 'Híbridos disponibles' },
    { id: 6, text: 'Datos de densidad y nitrógeno por híbrido' },
    { id: 7, text: 'Perfil defensivo de cada híbrido' },
    { id: 8, text: 'Variedades disponibles' },
    { id: 9, text: 'Perfil defensivo y características de cada variedad' },
    { id: 10, text: 'Mejores fechas de siembra para cada variedad' },
    { id: 11, text: 'Mapas histórico de enfermedades y plagas' },
    { id: 12, text: 'Unidades de medida' },
    { id: 13, text: 'Idiomas' },
    { id: 14, text: 'Fotos de malezas' },
];
